<div class="loading-screen">
    <img src="../../../../assets/img/animation.gif" />
    <p>{{message}}</p>
</div>